import { useEffect, useState } from "react";
import CheckboxCell from "../../../common/interactive/CheckboxCell";

export default function CheckBoxOption({filtersValues, item, mainSelectAction, classes, workQ, hideLabel}) {

    const [hideItem, setHideItem] = useState(false)
    useEffect(() => {
        if (workQ && workQ.filter_conditions) {
            if (workQ.filter_conditions[`${item.key}_filter_type`] && workQ.filter_conditions[`${item.key}_filter_type`] == 1) { //we have a rigid filter!!!
                setHideItem(true)
            }
        }
    }, [workQ, item])
    return <>
        {!hideItem && <div className={`${classes.row} ${classes.row_flex}`}>
            <CheckboxCell checked={filtersValues && filtersValues[item.key]} label={hideLabel ? null : item.label} name={item.key} identifier={{type: item.key}} direction={'reverse'} action={mainSelectAction}/>
        </div>}
    </>
}